class IsLogging {
  value: boolean = false;
}

export const isLogging = new IsLogging();